export enum TemperatureUnit {
	celsius = 'celsius',
	fahrenheit = 'fahrenheit',
}

export enum PressureUnit {
	mmHg = 'mmHg',
	dmHg = 'dmHg',
	hPa = 'hPa',
}

export enum SpeedUnit {
	ms = 'ms',
	kph = 'kph',
	mph = 'mph',
}

export enum ClockType {
	'12h' = '12',
	'24h' = '24',
}

export const temperatureUnitNames: Record<TemperatureUnit, string> = {
	[TemperatureUnit.celsius]: 'C',
	[TemperatureUnit.fahrenheit]: 'F',
};
